import type { GraftabilityIssue, GraftabilityIssueKind, GraftabilityMemberKind } from './types'

const FILTER_ADVICE_SUFFIX = ' Apply a `--types` filter when hosting with GG to expose only graft-compatible facades.'

const ISSUE_KIND_LABELS: Record<GraftabilityIssueKind, string> = {
  'complex-reference': 'Complex reference',
  'generic-type': 'Generic type',
  'unsupported-type': 'Unsupported type',
  'complex-array': 'Complex array',
}

export function getGraftabilityIssueKindLabel(kind: GraftabilityIssueKind): string {
  return ISSUE_KIND_LABELS[kind]
}

export function getGraftabilityIssueSummary(issue: GraftabilityIssue): string {
  if (issue.message.endsWith(FILTER_ADVICE_SUFFIX)) {
    return issue.message.slice(0, -FILTER_ADVICE_SUFFIX.length).trim()
  }

  return issue.message.trim()
}

export function formatGraftabilityMemberLocation(issue: GraftabilityIssue): string {
  if (!issue.memberName || !issue.memberKind) {
    return issue.classFqn ?? issue.typeLabel
  }

  const member = formatMemberKindLabel(issue.memberKind, issue.memberName)
  const classLabel = issue.classFqn ?? issue.className

  return classLabel ? `${classLabel} · ${member}` : member
}

function formatMemberKindLabel(memberKind: GraftabilityMemberKind, memberName: string): string {
  switch (memberKind) {
    case 'return':
      return `${memberName}() return type`
    case 'field':
      return `field ${memberName}`
    case 'constructor-parameter':
      return `constructor parameter ${memberName}`
    case 'parameter':
      return `parameter ${memberName}`
    default:
      return memberName
  }
}

export const GRAFTABILITY_FILTER_HINT =
  'Apply a `--types` filter when hosting with GG to expose only graft-compatible facades.'
